import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './index.css';
import App from './App';
import { BRAND_COLORS } from '@/shared/constants/colors';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <MantineProvider
      theme={{
        colors: {
          brand: BRAND_COLORS,
        },
        primaryColor: 'brand',
      }}
    >
      <Notifications />
      <App />
    </MantineProvider>
  </React.StrictMode>
);
